export enum MenuButtons {
  StreetView = 'Street View',
  DetailedReport = 'Detailed Report',
  SettingsAndCustomization = 'Settings And Customization',
  Tools = 'Tools',
  DeleteMarker = 'Delete Marker',
  NavigateToGoogle = 'NavigateToGoogle',
  NavigateToApple = 'NavigateToApple',
}
